import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARDS from '../apiUrls';

const mutationUpdateSimPlan = (onSuccess, onError) => {
    return {
        mutationFn: ({ offerId, simCardId }) => {
            return client.put(SIM_CARDS.SIM_PLAN_UPDATE.url, { offerId: offerId, simUuids: simCardId });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateSimPlan;